import styled from 'styled-components'

import { ColumnFlex } from '~/components/common/containers'
import { Label01 } from '~/components/common/typography'
import Avatar from '~/components/common/avatar'

export const Bubble = styled(ColumnFlex)`
  background-color: ${props => props.theme._neo.ui02};
  border-radius: 0px 6px 6px 6px;
  padding: 12px 16px;
  word-break: break-word;
`

export const Time = styled(Label01)`
  display: block;
  color: ${props => props.theme._neo.textColor02};
  margin-top: 4px;
`

export const BubbleContainer = styled.div`
  margin-left: 8px;
`

export const Content = styled.li`
  display: flex;
  margin-bottom: 8px;
`

export const ChatAvatar = styled(Avatar)`
  ${({ hidden }) => hidden && 'visibility: hidden'}
`
